import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'productGroup',
})
export class ProductGroupPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : string ) {
    return value === '*' ? this.translateService.instant('GENERAL_SPACE.BUTTON.ALL') : value;
  }
}